import { PureComponent } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import animationEffect from 'utils/animationEffect';
import handleEvent from 'utils/handleEvent';

const getMessageWrapperClassName = (type) => {
  switch (type) {
    case 0:
      return 'notifications__message-wrapper--0';
    case 10:
      return 'notifications__message-wrapper--10';
    case 20:
      return 'notifications__message-wrapper--20';
    case 30:
      return 'notifications__message-wrapper--30';
    default:
      return undefined;
  }
};

export default class Message extends PureComponent {
  static propTypes = {
    autoClose: PropTypes.bool,
    text: PropTypes.any,
    first: PropTypes.bool.isRequired,
    hash: PropTypes.string.isRequired,
    onHideNotification: PropTypes.func.isRequired,
    onRemoveNotification: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    type: PropTypes.number,
  };

  static defaultProps = {
    autoClose: true,
  };

  componentDidMount() {
    const { onHideNotification, hash, autoClose } = this.props;
    if (autoClose) {
      this.timeout = setTimeout(() => {
        const { origin, target } = this.getElements();
        if (origin && target && !this.animating) {
          this.animating = true;
          animationEffect({
            origin,
            target,
            type: 'squash',
            duration: 600,
          }).then(() => {
            onHideNotification({ hash, read: false });
          });
        } else {
          onHideNotification({ hash, read: false });
        }
      }, 3000);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.first && !this.props.first && !this.animating) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        if (!this.animating) {
          this.hideNotification();
        }
      }, 500);
    }
  }

  getElements = () => {
    const { hash } = this.props;
    const origin = document.querySelector(`#text-${hash}`);
    const target =
      document.querySelector('#header-notifications-messages-icon') ||
      document.querySelector('#header-notifications-toggle ');
    return { origin, target };
  };

  hideNotification = () => {
    const { onHideNotification, hash } = this.props;
    const { origin, target } = this.getElements();
    clearTimeout(this.timeout);
    if (origin && target && !this.animating) {
      this.animating = true;
      animationEffect({
        origin,
        target,
        type: 'squash',
        duration: 600,
      }).then(() => {
        onHideNotification({ hash, read: false });
      });
    } else {
      onHideNotification({ hash, read: false });
    }
  };

  handleClose = handleEvent(() => {
    const { onRemoveNotification, hash } = this.props;
    clearTimeout(this.timeout);
    if (!this.animating) {
      onRemoveNotification(hash);
    }
  });

  handleMouseOver = handleEvent(() => {
    clearTimeout(this.timeout);
  });

  handleMouseOut = handleEvent(() => {
    const { onHideNotification, hash, autoClose } = this.props;
    if (autoClose) {
      this.timeout = setTimeout(() => {
        const { origin, target } = this.getElements();
        if (origin && target && !this.animating) {
          this.animating = true;
          animationEffect({
            origin,
            target,
            type: 'squash',
            duration: 600,
          }).then(() => {
            onHideNotification({ hash, read: false });
          });
        } else {
          onHideNotification({ hash, read: false });
        }
      }, 2000);
    }
  });

  render() {
    const { text, type, title, hash } = this.props;
    const closableText = text && typeof text === 'function' && (
      <span className='notifications__message-text'>
        {text(this.handleClose)}
      </span>
    );

    return (
      <div
        id={`text-${hash}`}
        className={classNames(
          'notifications__message-wrapper',
          getMessageWrapperClassName(type),
        )}
        onMouseOver={this.handleMouseOver}
        onFocus={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
        onBlur={this.handleMouseOut}
      >
        <i
          className='fa fa-xmark notifications__message-close'
          onClick={this.handleClose}
        />
        {title && <span className='notifications__message-title'>{title}</span>}

        {text && typeof text === 'string' && text.length > 0 && (
          <span className='notifications__message-text'>{text}</span>
        )}
        {text && typeof text !== 'string' && typeof text !== 'function' && (
          <div>{text}</div>
        )}
        {closableText}
      </div>
    );
  }
}
